import {
    Autocomplete,
    FormControl,
    InputLabel,
    Select,
    TextField,
    Grid,
    MenuItem
  } from '@mui/material'
  import React from 'react'
  
  const ChestWall = ({ moduleValues, setModuleValues }) => (
    <Grid item xs={12} lg={4}>
       <FormControl fullWidth>
        <InputLabel>Chest Wall</InputLabel>
        <Select
          value={moduleValues?.['Chest Wall'] ?? ''}
          onChange={(e) =>setModuleValues(prev => ({...prev, ['Chest Wall']: e.target.value}))
          }
          label="Chest Wall"
        >
          <MenuItem value="Normal Chest Wall">Normal Chest Wall</MenuItem>
          <MenuItem value="Deformities">Deformities</MenuItem>
          <MenuItem value="Masses">Masses</MenuItem>
          <MenuItem value="Tenderness">Tenderness</MenuItem>
          <MenuItem value="Scars">Scars</MenuItem>
          <MenuItem value="Chest Wall Abnormalities">Chest Wall Abnormalities</MenuItem>
          <MenuItem value="No Abnormalities Noted">No Abnormalities Noted</MenuItem>
        </Select>
      </FormControl>
    </Grid>
  )
  
  export default ChestWall
  